import request from '@/utils/request'

let WorkforceApi = {

  /*排班列表*/
  list(data) {
    return request._post('/shop/plus.workforce.workforce.Index/index', data);
},
/*添加排班*/
add(data) {
    return request._post('/shop/plus.workforce.workforce.Index/add', data);
},
/*修改排班*/
edit(data) {
    return request._post('/shop/plus.workforce.workforce.Index/edit', data);
},
/*删除排班*/
del(data) {
    return request._post('/shop/plus.workforce.workforce.Index/del', data);
},
/*排班详情*/
detail(data) {
  return request._post('/shop/plus.workforce.workforce.Index/detail', data);
},
setStatus(data) {
  return request._post('/shop/plus.workforce.workforce.Index/setStatus', data);
},
setStatusf(data) {
  return request._post('/shop/plus.workforce.workforce.Index/setStatusf', data);
},
record(data) {
  return request._post('/shop/plus.workforce.workforce.Index/record', data);
},
}
export default WorkforceApi;



// WEBPACK FOOTER //
// ./src/api/workforce.js